import { Subscription, Subject } from "rxjs";
import { Injector, Inject } from "@angular/core";
import { AuthorityService } from "@root/shared/business-sevice/authority.service";
import { StoreService } from "@root/shared/service/store.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { TranslateService } from "@root/shared/service/translate.service";
import { InjectorService } from '@root/injector.service';
import { takeUntil } from "rxjs/operators";
/**
 * 装饰器模块
 */
type PropDecorator = (target: any, propName: string) => void;
function propDecoratorFactory<T, D>(
  name: string,
  callback: (v: T) => D
): PropDecorator {
  function propDecorator(target: any, propName: string) {
    const privatePropName = `$__${propName}`;

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true
    });

    Object.defineProperty(target, propName, {
      get() {
        return this[privatePropName];
      },
      set(value: T) {
        this[privatePropName] = callback(value);
      }
    });
  }

  return propDecorator;
}


/** 延迟time时间后，将该属性置为flase */
export function BeFalseAfter(time = 1000) {
  return (target, propName) => {

    const privatePropName = `$__${propName}`;
    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true
    });

    Object.defineProperty(target, propName, {
      get() {
        return target[privatePropName];
      },
      set(value: boolean) {
        target[privatePropName] = value;
        if (value) {
          const id = setTimeout(() => {
            target[privatePropName] = false;

            clearTimeout(id);
          }, time);
        }
      }
    });
  };
}

/**
 * 互斥
 * 即当propName为true的时候，otherField必须为false
 */
export function Mutex(otherField) {
  return (target, propName) => {
    const privatePropName = `$__${propName}`;

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true
    });

    Object.defineProperty(target, propName, {
      get() {
        return target[privatePropName];
      },
      set(value: boolean) {
        target[privatePropName] = value;
        if (value) {
          target[otherField] = !value;
        }
      }
    });
  };
}

export function Translate(i18nKey) {
  return (target, propName) => {
    const privatePropName = `$__${propName}`;

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true
    });

    Object.defineProperty(target, propName, {
      get() {
        const translate = InjectorService.injector.get(TranslateService);
        return translate.syncGet(i18nKey);
      }
    });
  }
}

export function Loading(field = "loading") {
  return (target, prop, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function () {
      this[field] = true;
      const subs: Subscription = method.apply(this, arguments);
      let id = setInterval(() => {
        if (!subs || (subs && subs.closed)) {
          this[field] = false;
          clearInterval(id);
          id = null;
        }
      }, 100);
    };
  };
}

export function ExpiredGurd(service = 'editionStatusService') {
  return (target, prop, descriptor) => {
    const method = descriptor.value;

    descriptor.value = function () {
      const editionService = this[service] || target[service];
      if (editionService.isExpired()) {
        editionService.notifyForPagesNotAllowed();
        return;
      }

      method.apply(this, arguments);
    }
  }
}

export function WritePermissionGurd(permission) {
  return (target, prop, descriptor) => {
    const method = descriptor.value;

    descriptor.value = function () {
      const translate = InjectorService.injector.get(TranslateService);
      const authority = InjectorService.injector.get(AuthorityService);
      const modal = InjectorService.injector.get(NzModalService);

      if (!authority.hasWritePermission(permission)) {
        modal.warning({
          nzTitle: translate.syncGet('errorText.no_write_authority')
        });
        return;
      }

      method.apply(this, arguments);
    }
  }
}

export function OnLangChangeUntil(destroy: string) {
  return (target, prop, descriptor) => {
    const method = descriptor.value;

    descriptor.value = function () {
      const params = arguments;
      const translate = InjectorService.injector.get(TranslateService);
      const destroy$ = this[destroy] || target[destroy];

      translate
        .onLangChange()
        .pipe(takeUntil(destroy$))
        .subscribe(langChangeEvent => {
          method.apply(this, params);
        });

      method.apply(this, arguments);
    }

  }
}

// export function ObservableAOP(taps: Array<OperatorFunction<any, any>>) {
//   return (target, prop, descriptor) => {
//     const method = descriptor.value;
//     console.log('method: ', method);
//     descriptor.value = function() {
//       let observable: Observable<any> = method.apply(this, arguments);
//       console.log('arguments: ', arguments);
//       taps.forEach(function(tap) {
//         observable = observable.pipe(tap);
//       });
//       console.log('observable: ', observable);
//       observable['__arguments__'] = Array.from(arguments);
//       return observable;
//     };

//     console.log('descriptor: ', descriptor);

//     return descriptor;
//   };
// }

// export function Destroy() {
//   return (target, prop) => {
//     console.log('target: ', target);
//     console.log('prop: ', prop);
//     let value = target[prop];
//     console.log('value: ', value);
//     // if (!target['ngOnDestroy']) {
//     //   target['ngOnDestroy'] = () => {};
//     // }
//     const destroyFn = target['ngOnDestroy'];
//     console.log('destroyFn: ', destroyFn);
//     target['ngOnDestroy'] = function() {
//       console.log('wrapper destroy');
//       destroyFn.apply(this);
//       console.log('value: ', target[prop]);
//       value.next();
//       value.complete();
//       value = null;
//       console.log('value: ', target[prop]);
//     };
//   };
// }
